export { ViajesIndex } from "./container/index";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajes/index.tsx